import React, { useState, useRef } from 'react'
import { FormMessage } from 'choice-forms'
import { post } from '../../utils/apiClient'
import {
  Button,
  Header,
  Icon,
  Modal,
  Input,
  Form,
  Message,
  Segment
} from 'semantic-ui-react'

export default function PasswordResetModal({ modalAction }) {
  const [state, setState] = useState({
    email: null,
    confirm_uid: null,
    confirmed_code: null,
    processing_submit: false,
    form_message: null
  })

  const closeModal = () => {
    if (state.is_loading) return
    modalAction({ close_modal: true })
  }

  let refEmailInput = useRef()
  let refCodeInput = useRef()
  let refPasswordInput = useRef()

  const resetPasswordRequest = async () => {
    if (state.processing_submit === true) return false
    let email = refEmailInput.current.value.trim()
    if (!email) {
      return setState({
        ...state,
        form_message: {
          errors: [{ message: 'Please provide an email address.' }]
        }
      })
    }

    setState({ ...state, processing_submit: true })
    let res = await post('/api/password-reset/request', {
      data: { email },
      show_msg: false
    })
    if (res.ok) {
      setState({
        ...state,
        processing_submit: false,
        email,
        confirm_uid: res.confirm,
        form_message: null
      })
      refCodeInput.current.focus()
      // setState({ ...state,  form_message: res, processing_submit: false });
    } else if (res) {
      setState({ ...state, form_message: res, processing_submit: false })
    }
  }

  const confirmCode = async () => {
    if (state.processing_submit) return false
    let confirmed_code = refCodeInput.current.value.trim()
    if (!confirmed_code) {
      return setState({
        ...state,
        form_message: {
          errors: [
            {
              message:
                'Please provide the verification code.  It cannot be blank.'
            }
          ]
        }
      })
    }
    setState({ ...state, processing_submit: true, form_message: null })
    let res = await post('/api/password-reset/confirm', {
      data: {
        email: state.email,
        confirm: state.confirm_uid,
        code: confirmed_code
      },
      show_msg: false
    })
    if (res.ok) {
      setState({
        ...state,
        confirmed_code,
        processing_submit: false,
        form_message: null
      })
      refPasswordInput.current.focus()
    } else if (res) {
      setState({ ...state, form_message: res, processing_submit: false })
    }
  }

  const submitPassword = async () => {
    if (state.processing_submit) return false
    let password = refPasswordInput.current.value.trim()

    if (!password) {
      return setState({
        ...state,
        form_message: { errors: [{ message: 'Please enter a password.' }] },
        processing_submit: false
      })
    }

    setState({ ...state, processing_submit: true, form_message: null })
    let res = await post('/api/password-reset/submit', {
      data: {
        password,
        email: state.email,
        code: state.confirmed_code,
        confirm: state.confirm_uid
      },
      show_msg: false
    })
    if (res.ok) {
      setState({
        ...state,
        processing_submit: false,
        email: null,
        confirm_uid: null,
        confirmed_code: null,
        form_message: 'done'
      })
      modalAction({ close_modal: true })
    } else if (res) {
      setState({ ...state, form_message: res, processing_submit: false })
    }
  }

  return (
    <>
      <Modal
        open={true}
        size="fullscreen"
        centered={false}
        style={{ maxWidth: '481px' }}>
        <Icon name="close" onClick={() => closeModal()} />
        <Header>Password Reset</Header>
        <Modal.Content>
          {state.email ? (
            <>
              {state.confirmed_code ? (
                <Form size="large">
                  <Segment
                    stacked
                    textAlign="left"
                    className="reg-form-fields-container ">
                    <Form.Field>
                      <label htmlFor="password">Password</label>
                      <Input
                        placeholder="Password"
                        fluid
                        type="password"
                        ref={refPasswordInput}
                      />
                    </Form.Field>
                    {state.form_message && (
                      <FormMessage {...state.form_message} />
                    )}
                    <Button
                      primary
                      fluid
                      content="Submit"
                      size="large"
                      loading={state.processing_submit}
                      onClick={() => submitPassword()}
                    />
                  </Segment>
                </Form>
              ) : (
                <Form size="large">
                  <Segment
                    stacked
                    textAlign="left"
                    className="reg-form-fields-container ">
                    <Message
                      negative
                      content="Please verify to reset password."
                    />
                    <Form.Field>
                      <p>
                        A verification code has been sent to{' '}
                        <strong>{state.email}</strong>.
                      </p>
                      <p>
                        Please enter the verification code from that e-mail.
                      </p>
                    </Form.Field>
                    <Form.Field>
                      <Input
                        placeholder="Verification code"
                        fluid
                        type="text"
                        name="code"
                        ref={refCodeInput}
                        icon="lock"
                        iconPosition="left"
                      />
                    </Form.Field>
                    {state.form_message && (
                      <FormMessage {...state.form_message} />
                    )}
                    <Button
                      primary
                      fluid
                      content="Verify"
                      size="large"
                      loading={state.processing_submit}
                      onClick={() => confirmCode()}
                    />
                    <Segment style={{ marginTop: '50px' }}>
                      <h3>{`Haven't received the e-mail?`}</h3>
                      <p>Please try again later, or check the following:</p>
                      <ul>
                        <li>
                          Check that the e-mail address you entered is correct.
                        </li>
                        <li>
                          Check that you have entered an e-mail address that you
                          already registered.
                        </li>
                        <li>Check your spam/junk e-mail folder.</li>
                        <li>
                          Make sure there are no filters in your e-mail account
                          that may be blocking e-mails from @courseflow.net.
                        </li>
                      </ul>
                    </Segment>
                  </Segment>
                </Form>
              )}
            </>
          ) : (
            <>
              {/* <p>Enter your email address and we will send you a link to reset your password.</p> */}
              <div id="msgBefore" className="ui form">
                <label htmlFor="email">Email address</label>{' '}
                {/* add username and email ? */}
                <div className="field">
                  <div className="ui input">
                    <Input
                      placeholder="Email address"
                      type="text"
                      autoFocus
                      ref={refEmailInput}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') resetPasswordRequest()
                      }}
                    />
                  </div>
                </div>
                {state.form_message && <FormMessage {...state.form_message} />}
                <div className="field">
                  <div
                    className="alink"
                    style={{ display: 'inline' }}
                    onClick={() => modalAction({ close_modal: true })}>
                    ← Back to sign in
                  </div>
                  <Button
                    primary
                    style={{ float: 'right' }}
                    onClick={resetPasswordRequest}
                    loading={state.processing_submit}
                    content="Submit"
                  />
                </div>
              </div>
            </>
          )}
        </Modal.Content>
      </Modal>
    </>
  )
}
